<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <NonAutorise v-show="PageNonAutorise" />
  </div>
</template>
<script>
import axios from "axios";
import NonAutorise from "@/components/PageNonAutoriseExtranet";

export default {
  name: "PageManager",
  components: {
    NonAutorise,
  },
  data() {
    return {
      loader: true,
      PageNonAutorise: true,
    };
  },
  mounted() {
    this.Manage();
  },
  methods: {
    Manage() {
      if (this.$route.query.t && this.$route.query.page) {
        let token = this.$route.query.t;
        let page = this.$route.query.page;
        axios
          .create({
            baseURL: process.env.VUE_APP_BASE_API_URL,
            withCredentials: false,
            headers: {
              Accept: "application/json",
              token: token,
            },
          })
          .get("extranet/ValiderToken")
          .then((reponse) => {
            if (reponse.status == 200 && reponse.data && reponse.data.ppid) {
              if (!reponse.errorMsg) {
                this.PageNonAutorise = !reponse.data.success;
                if (page == "concours") {
                  window.location.href = "#/Concours?t=" + token;
                } else if (page == "demande") {
                  window.location.href = "#/Bourse?t=" + token;
                } else if (page == "annexes") {
                  window.location.href = "#/Annexes?t=" + token;
                } else if (page == "conversations") {
                  window.location.href = "#/Conversation/liste?token=" + token;
                } else if (page == "dossier") {
                  window.location.href = "#/ListeDb?t=" + token;
                } else if (page == "inscription") {
                  window.location.href = "#/InscriptionUniversite?t=" + token;
                } else if (page == "annexesinscr") {
                  window.location.href = "#/AnnexesInscrUm6p?t=" + token;
                } else if (page == "becr") {
                  window.location.href = "#/CandidatureBourseFirsi?t=" + token;
                } else if (page == "PJBECR") {
                  window.location.href = "#/AnnexesBecr?t=" + token;
                } else if (page == "ListeCb") {
                  window.location.href = "#/ListeCb?t=" + token;
                } else if (page === "sousmenuum6p") {
                  window.location.href = "#/SousMenuUm6p?t=" + token;
                } else if (page === "resultatbac") {
                  window.location.href = "#/resultatbac?t=" + token;
                } else if (page === "listebourses") {
                  window.location.href = "#/listebourses?t=" + token;
                } else if (page === "AnnexeEcoleCentrale") {
                  window.location.href = "#/AnnexeEcoleCentrale?t=" + token;
                } else {
                  this.PageNonAutorise = true;
                  this.loader = false;
                }
              }
            } else {
              this.PageNonAutorise = true;
              this.loader = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.PageNonAutorise = true;
            this.loader = false;
          });
      }
    },
  },
};
</script>
